/**
 * Class-name composition.
 *
 * `clsx` handles conditionals; `tailwind-merge` resolves conflicts so a caller's
 * `p-4` beats a component's default `p-2` instead of both landing and the
 * winner depending on stylesheet order.
 */
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
